// extracted by mini-css-extract-plugin
export default {"info":"tweet-info_info__E5tzv","infoLink":"tweet-info_infoLink__9G58G","infoIcon":"tweet-info_infoIcon__3U3wr"};